(() => {
  window.__dcsWishlistInteractionsInitialized = true;

  const WISHLIST_CONFIG = window.DCSWishlist.config;
  const updateButtons = window.DCSWishlist.updateButtons;
  const updateWishlistBubble = window.DCSWishlist.updateBubble;

  // Enhanced click handler with better error handling and loading states
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('[data-wishlist-id], [data-ihaveit-id]');
    if (!btn) return;

    // Prevent double-clicks
    if (btn.disabled || btn.classList.contains(WISHLIST_CONFIG.classes.loading)) {
      return;
    }

    // Stop link navigation
    event.preventDefault();
    event.stopPropagation();

    // Determine action type and product details
    const isWishlistBtn = btn.hasAttribute('data-wishlist-id');
    const actionType = isWishlistBtn ? 'wishlist' : 'iHaveIt';
    const productId = btn.dataset[isWishlistBtn ? 'wishlistId' : 'ihaveitId'];
    const productHandle = btn.dataset.productHandle;

    if (!productId || !productHandle) {
      console.error('Missing required data attributes');
      return;
    }

    const list = actionType === 'wishlist' ? window.__wishlist : window.__iHaveIt;
    const isInList = list.some((item) => item.productId.toString() === productId);

    // Prepare form data
    const formData = new FormData();
    formData.append('productId', productId);
    formData.append('productHandle', productHandle);
    formData.append('type', actionType);
    formData.append('_action', isInList ? 'DELETE' : 'CREATE');

    // Add customer data if available (Shopify template variables)

    formData.append('customerName', window.customerName);
    formData.append('customerEmail', window.customerEmail);

    // Set loading state
    btn.disabled = true;
    btn.classList.add(WISHLIST_CONFIG.classes.loading);

    try {
      const res = await fetch(WISHLIST_CONFIG.endpoints.update, {
        method: 'POST',
        body: formData,
        headers: {
          Accept: 'application/json',
        },
      });

      if (!res.ok) {
        throw new Error(`HTTP ${res.status}: ${res.statusText}`);
      }

      const result = await res.json();

      if (result.ok) {
        // Update local state
        const updatedList = isInList
          ? list.filter((item) => item.productId.toString() !== productId)
          : [...list, { productId, productHandle }];

        // Update global variables and storage
        if (actionType === 'wishlist') {
          window.__wishlist = updatedList;
          sessionStorage.setItem(WISHLIST_CONFIG.storage.wishlist, JSON.stringify(updatedList));
        } else {
          window.__iHaveIt = updatedList;
          sessionStorage.setItem(WISHLIST_CONFIG.storage.iHaveIt, JSON.stringify(updatedList));
        }

        // Update UI
        updateButtons(actionType, updatedList);
        updateWishlistBubble();
        // Dispatch custom event for other components
        document.dispatchEvent(
          new CustomEvent(`${actionType}:updated`, {
            detail: {
              productId,
              productHandle,
              action: isInList ? 'removed' : 'added',
              list: updatedList,
            },
          }),
        );

        // Show success feedback (optional)
        showToast(
          `${isInList ? 'Removed from' : 'Added to'} ${actionType === 'wishlist' ? 'wishlist' : 'owned items'}!`,
        );
      } else {
        throw new Error(result.message || 'Failed to update list');
      }
    } catch (error) {
      console.error('❌ Error updating list:', error);
      showToast('Please Login to use Wishlist', 'error');
    } finally {
      // Remove loading state
      btn.disabled = false;
      btn.classList.remove(WISHLIST_CONFIG.classes.loading);
    }
  });

  // Optional: Simple toast notification system
  function showToast(message, type = 'success') {
    // Create container if missing
    let toastContainer = document.querySelector('.toast-container');
    if (!toastContainer) {
      toastContainer = document.createElement('div');
      toastContainer.className = 'toast-container';
      toastContainer.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 20px;
      z-index: 10000;
      pointer-events: none;
    `;
      document.body.appendChild(toastContainer);
    }

    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    toast.textContent = message;
    toast.style.cssText = `
    background: ${type === 'error' ? '#cc0000' : '#4caf50'};
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    margin-bottom: 10px;
    opacity: 0;
    transform: translateX(-100%); /* start off-screen to the left */
    transition: all 0.3s ease;
    pointer-events: auto;
  `;

    toastContainer.appendChild(toast);

    // Animate in (slide from left to right)
    setTimeout(() => {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(0)';
    }, 10);

    // Auto remove
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-100%)'; // slide back to left
      setTimeout(() => {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 3000);
  }
})();
